import { createSlice } from "@reduxjs/toolkit"
import axios from "axios"

const initialState = {
    // Checkout
    checkoutLoading: false,
    checkoutSuccess: false,
    checkoutFail: false,
    checkoutData: null, // { order_id, order_number, total_credit_cost, etc }
    checkoutErrorMessage: null,

    // Get Orders
    getOrdersLoading: false,
    getOrdersSuccess: false,
    getOrdersFail: false,
    getOrdersData: null,
    getOrdersErrorMessage: null,

    // Get Order Details
    getOrderDetailsLoading: false,
    getOrderDetailsSuccess: false,
    getOrderDetailsFail: false,
    getOrderDetailsData: null,
    getOrderDetailsErrorMessage: null,

    // Confirm Receive
    confirmReceiveLoading: false,
    confirmReceiveSuccess: false,
    confirmReceiveFail: false,
    confirmReceiveErrorMessage: null,

    // Cancel Order
    cancelOrderLoading: false,
    cancelOrderSuccess: false,
    cancelOrderFail: false,
    cancelOrderErrorMessage: null,
}

export const checkoutSlice = createSlice({
    name: "checkout",
    initialState,
    reducers: {
        // Checkout Actions
        checkoutRequest: (state) => {
            state.checkoutLoading = true
            state.checkoutSuccess = false
            state.checkoutFail = false
            state.checkoutErrorMessage = null
        },
        checkoutSuccessAction: (state, action) => {
            state.checkoutLoading = false
            state.checkoutSuccess = true
            state.checkoutFail = false
            state.checkoutData = action.payload
            state.checkoutErrorMessage = null
        },
        checkoutFailAction: (state, action) => {
            state.checkoutLoading = false
            state.checkoutSuccess = false
            state.checkoutFail = true
            state.checkoutErrorMessage = action.payload
        },
        resetCheckout: (state) => {
            state.checkoutLoading = false
            state.checkoutSuccess = false
            state.checkoutFail = false
            state.checkoutData = null
            state.checkoutErrorMessage = null
        },

        // Get Orders Actions
        getOrdersRequest: (state) => {
            state.getOrdersLoading = true
            state.getOrdersSuccess = false
            state.getOrdersFail = false
            state.getOrdersErrorMessage = null
        },
        getOrdersSuccessAction: (state, action) => {
            state.getOrdersLoading = false
            state.getOrdersSuccess = true
            state.getOrdersFail = false
            state.getOrdersData = action.payload
            state.getOrdersErrorMessage = null
        },
        getOrdersFailAction: (state, action) => {
            state.getOrdersLoading = false
            state.getOrdersSuccess = false
            state.getOrdersFail = true
            state.getOrdersErrorMessage = action.payload
        },
        resetGetOrders: (state) => {
            state.getOrdersLoading = false
            state.getOrdersSuccess = false
            state.getOrdersFail = false
            state.getOrdersData = null
            state.getOrdersErrorMessage = null
        },

        // Get Order Details Actions
        getOrderDetailsRequest: (state) => {
            state.getOrderDetailsLoading = true
            state.getOrderDetailsSuccess = false
            state.getOrderDetailsFail = false
            state.getOrderDetailsErrorMessage = null
        },
        getOrderDetailsSuccessAction: (state, action) => {
            state.getOrderDetailsLoading = false
            state.getOrderDetailsSuccess = true
            state.getOrderDetailsFail = false
            state.getOrderDetailsData = action.payload
            state.getOrderDetailsErrorMessage = null
        },
        getOrderDetailsFailAction: (state, action) => {
            state.getOrderDetailsLoading = false
            state.getOrderDetailsSuccess = false
            state.getOrderDetailsFail = true
            state.getOrderDetailsErrorMessage = action.payload
        },
        resetGetOrderDetails: (state) => {
            state.getOrderDetailsLoading = false
            state.getOrderDetailsSuccess = false
            state.getOrderDetailsFail = false
            state.getOrderDetailsData = null
            state.getOrderDetailsErrorMessage = null
        },

        // Confirm Receive Actions
        confirmReceiveRequest: (state) => {
            state.confirmReceiveLoading = true
            state.confirmReceiveSuccess = false
            state.confirmReceiveFail = false
            state.confirmReceiveErrorMessage = null
        },
        confirmReceiveSuccessAction: (state) => {
            state.confirmReceiveLoading = false
            state.confirmReceiveSuccess = true
            state.confirmReceiveFail = false
            state.confirmReceiveErrorMessage = null
        },
        confirmReceiveFailAction: (state, action) => {
            state.confirmReceiveLoading = false
            state.confirmReceiveSuccess = false
            state.confirmReceiveFail = true
            state.confirmReceiveErrorMessage = action.payload
        },
        resetConfirmReceive: (state) => {
            state.confirmReceiveLoading = false
            state.confirmReceiveSuccess = false
            state.confirmReceiveFail = false
            state.confirmReceiveErrorMessage = null
        },

        // Cancel Order Actions
        cancelOrderRequest: (state) => {
            state.cancelOrderLoading = true
            state.cancelOrderSuccess = false
            state.cancelOrderFail = false
            state.cancelOrderErrorMessage = null
        },
        cancelOrderSuccessAction: (state) => {
            state.cancelOrderLoading = false
            state.cancelOrderSuccess = true
            state.cancelOrderFail = false
            state.cancelOrderErrorMessage = null
        },
        cancelOrderFailAction: (state, action) => {
            state.cancelOrderLoading = false
            state.cancelOrderSuccess = false
            state.cancelOrderFail = true
            state.cancelOrderErrorMessage = action.payload
        },
        resetCancelOrder: (state) => {
            state.cancelOrderLoading = false
            state.cancelOrderSuccess = false
            state.cancelOrderFail = false
            state.cancelOrderErrorMessage = null
        },
    },
})

// Action creators
export const {
    checkoutRequest,
    checkoutSuccessAction,
    checkoutFailAction,
    resetCheckout,
    getOrdersRequest,
    getOrdersSuccessAction,
    getOrdersFailAction,
    resetGetOrders,
    getOrderDetailsRequest,
    getOrderDetailsSuccessAction,
    getOrderDetailsFailAction,
    resetGetOrderDetails,
    confirmReceiveRequest,
    confirmReceiveSuccessAction,
    confirmReceiveFailAction,
    resetConfirmReceive,
    cancelOrderRequest,
    cancelOrderSuccessAction,
    cancelOrderFailAction,
    resetCancelOrder,
} = checkoutSlice.actions

// Selectors
export const getCheckoutLoading = (state) => state.checkout.checkoutLoading
export const getCheckoutSuccess = (state) => state.checkout.checkoutSuccess
export const getCheckoutFail = (state) => state.checkout.checkoutFail
export const getCheckoutData = (state) => state.checkout.checkoutData
export const getCheckoutErrorMessage = (state) => state.checkout.checkoutErrorMessage

export const getOrdersLoading = (state) => state.checkout.getOrdersLoading
export const getOrdersSuccess = (state) => state.checkout.getOrdersSuccess
export const getOrdersFail = (state) => state.checkout.getOrdersFail
export const getOrdersData = (state) => state.checkout.getOrdersData
export const getOrdersErrorMessage = (state) => state.checkout.getOrdersErrorMessage

export const getOrderDetailsLoading = (state) => state.checkout.getOrderDetailsLoading
export const getOrderDetailsSuccess = (state) => state.checkout.getOrderDetailsSuccess
export const getOrderDetailsFail = (state) => state.checkout.getOrderDetailsFail
export const getOrderDetailsData = (state) => state.checkout.getOrderDetailsData
export const getOrderDetailsErrorMessage = (state) => state.checkout.getOrderDetailsErrorMessage

export const getConfirmReceiveLoading = (state) => state.checkout.confirmReceiveLoading
export const getConfirmReceiveSuccess = (state) => state.checkout.confirmReceiveSuccess
export const getConfirmReceiveFail = (state) => state.checkout.confirmReceiveFail
export const getConfirmReceiveErrorMessage = (state) => state.checkout.confirmReceiveErrorMessage

export const getCancelOrderLoading = (state) => state.checkout.cancelOrderLoading
export const getCancelOrderSuccess = (state) => state.checkout.cancelOrderSuccess
export const getCancelOrderFail = (state) => state.checkout.cancelOrderFail
export const getCancelOrderErrorMessage = (state) => state.checkout.cancelOrderErrorMessage

// Thunks (API calls)

/**
 * Checkout - Create order from cart
 * @param {object} shippingData - Shipping information
 */
export const doCheckout = (shippingData) => {
    return async (dispatch) => {
        dispatch(checkoutRequest())

        try {
            const response = await axios.post(
                `/api/customer/checkout`,
                shippingData
            )

            dispatch(checkoutSuccessAction(response.data.data))
            return response.data
        } catch (error) {
            const errorMessage = error.response?.data?.errorMessage || error.message || "Network error occurred"
            dispatch(checkoutFailAction(errorMessage))
            throw error
        }
    }
}

/**
 * Get customer orders
 * @param {string} status - Optional status filter
 */
export const doGetOrders = (status = null) => {
    return async (dispatch) => {
        dispatch(getOrdersRequest())

        try {
            const url = status ? `/api/customer/orders?status=${status}` : `/api/customer/orders`
            const response = await axios.get(url)

            dispatch(getOrdersSuccessAction(response.data))
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Network error occurred"
            dispatch(getOrdersFailAction(errorMessage))
        }
    }
}

/**
 * Get order details
 * @param {number} orderId - Order ID
 */
export const doGetOrderDetails = (orderId) => {
    return async (dispatch) => {
        dispatch(getOrderDetailsRequest())

        try {
            const response = await axios.get(`/api/customer/orders/${orderId}`)

            dispatch(getOrderDetailsSuccessAction(response.data.data))
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Network error occurred"
            dispatch(getOrderDetailsFailAction(errorMessage))
        }
    }
}

/**
 * Confirm receive order
 * @param {number} orderId - Order ID
 */
export const doConfirmReceive = (orderId) => {
    return async (dispatch) => {
        dispatch(confirmReceiveRequest())

        try {
            await axios.put(`/api/customer/orders/${orderId}/confirm-receive`)
            dispatch(confirmReceiveSuccessAction())
        } catch (error) {
            const errorMessage = error.response?.data?.errorMessage || error.message || "Network error occurred"
            dispatch(confirmReceiveFailAction(errorMessage))
        }
    }
}

/**
 * Cancel order (customer - only pending orders within 1 hour)
 * @param {number} orderId - Order ID
 */
export const doCancelOrder = (orderId) => {
    return async (dispatch) => {
        dispatch(cancelOrderRequest())

        try {
            await axios.post(`/api/customer/orders/${orderId}/cancel`)
            dispatch(cancelOrderSuccessAction())
        } catch (error) {
            const errorMessage = error.response?.data?.errorMessage || error.message || "Failed to cancel order"
            dispatch(cancelOrderFailAction(errorMessage))
        }
    }
}

export default checkoutSlice.reducer
